export default __webpack_public_path__ + "static/media/btn-arr.b2623ada.svg";